import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, inject, output, signal, WritableSignal } from '@angular/core';

import { NoDataToDisplayComponent } from '@connect-services/client/components/no-data-to-display/no-data-to-display.component';
import { StatisticEditOrderComponent } from '@connect-services/client/components/statistics/edit-order/statistic-edit-order/statistic-edit-order.component';
import { STATISTIC_CLASS_HALF, StatisticService } from '@connect-services/client/services/statistic.service';
import { ComputedStatistic } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CdkDrag,
        CdkDropList,
        LoadingComponent,
        NoDataToDisplayComponent,
        StatisticEditOrderComponent,
        RessourcesModule,
    ],
    selector: 'app-edit-order',
    styleUrl: './edit-order.component.scss',
    templateUrl: './edit-order.component.html',
})
export class EditOrderComponent {
    public orderChanged = output<void>();

    protected readonly isDragging: WritableSignal<boolean> = signal(false);
    protected readonly STATISTIC_CLASS_HALF = STATISTIC_CLASS_HALF;
    protected readonly statisticService = inject(StatisticService);

    public moveStatistic(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.statisticService.computedStatisticList(), event.previousIndex, event.currentIndex);

        this.orderChanged.emit();
    }

    public shouldRenderHalfPlaceholder(index: number): boolean {
        const computedStatisticList: ComputedStatistic[] = this.statisticService.computedStatisticList();
        const current = computedStatisticList[index];

        if (!this.statisticService.isHalfStatistic(current)) {
            return false;
        }

        let halfCountSinceBreak = 0;
        for (let i = index; i >= 0; i--) {
            if (!this.statisticService.isHalfStatistic(computedStatisticList[i])) {
                break;
            }
            halfCountSinceBreak++;
        }

        if (halfCountSinceBreak % 2 === 0) {
            return false;
        }
        const next = computedStatisticList[index + 1];

        return !this.statisticService.isHalfStatistic(next);
    }
}
